import theme from 'src/styles/theme'
import { PrinterIcon } from './PrintInvoicesSection.style'

export enum PrintInvoicesStepsEnum {
  FILL_BADGE_AND_PASSWORD = 0,
  START_PRINT_OR_RETURN = 1,
  PRINT_INVOICES = 2,
  CONFIRM_PRINTS = 3,
}

export interface SectionLabelState {
  color: string,
  title: string,
  icon: JSX.Element,
}

export interface InvoicesToPrint {
  invoices?: string[]
  isPrinted: boolean
  type: PrintInvoicesTypes
}

export enum PrintInvoicesTypes {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  RETURN = 'return',
}

export const PrintInvoicesTypesObject = {
  [PrintInvoicesTypes.ACCEPTED]: {
    sectionLabel: {
      color: theme.colors.green2,
      title: 'NOTAS FISCAIS ACEITAS',
      icon: <PrinterIcon />,
    },
    observations: [
      'VOCÊ deve assinar o canhoto e devolver ao FORNECEDOR',
      'A nota fiscal deverá ficar com VOCÊ.',
    ],
  },
  [PrintInvoicesTypes.RETURN]: {
    sectionLabel: {
      color: theme.colors.orange,
      title: 'NOTAS FISCAIS DE DEVOLUÇÃO',
      icon: <PrinterIcon />,
    },
    observations: [
      'O FORNECEDOR deve assinar o canhoto',
      'O canhoto deve ficar com VOCÊ e a Nota Fiscal com o FORNECEDOR.',
    ],
  },
  [PrintInvoicesTypes.REJECTED]: {
    sectionLabel: {
      color: theme.colors.red2,
      title: 'NOTAS FISCAIS RECUSADAS',
      icon: <PrinterIcon />,
    },
    observations: [
      'VOCÊ deve entegar o canhoto em branco ao FORNECEDOR',
      'A nota fiscal deve ser DEVOLVIDA ao FORNECEDOR.',
    ],
  },
}
